import { Check as CheckIcon, Close as CloseIcon } from "@mui/icons-material";
import { Box } from "@mui/material";
import { DateRange, DateRangePicker } from "@mui/x-date-pickers-pro";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  DEFAULT_DRAG_HANDLE_SELECTOR,
  NO_DRAG_SELECTOR,
} from "../../../app/constants";
import { CustomButton } from "../../../common/components/functional/customButton/CustomButton";

interface Props {
  setReportModal: (value: boolean) => void;
}

const UnionReportModal = ({ setReportModal }: Props) => {
  const [dateRange, setDateRange] = useState<DateRange<Date>>([null, null]);

  // FIXME: should shouldUpdate be used?
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [shouldUpdate, setShouldUpdate] = useState<boolean>(false);

  const { t } = useTranslation();

  const handleGenerateReport = () => {
    // TODO: Generate report
  };

  const handleDateRangeOnChange = (dateRange: DateRange<Date>) => {
    setDateRange(dateRange);
  };

  return (
    <Box
      className={DEFAULT_DRAG_HANDLE_SELECTOR}
      sx={{
        width: "572px",
        display: "flex",
        flexDirection: "column",
        borderTopRightRadius: "12px",
        borderTopLeftRadius: "12px",
        padding: "20px 20px 20px 20px",
        cursor: "grab",
      }}
    >
      <Box
        sx={{
          fontSize: "16px",
          fontWeight: "600",
          marginBottom: "30px",
        }}
      >
        {t("settings:chooseReportDateRange").toUpperCase()}
      </Box>
      <Box className={NO_DRAG_SELECTOR} sx={{ cursor: "auto" }}>
        <DateRangePicker
          format="dd.MM.yyyy"
          value={dateRange || [null, null]}
          onChange={handleDateRangeOnChange}
          onClose={() => setShouldUpdate(true)}
          slotProps={{
            textField: {
              size: "small",
              label: null,
              onKeyUp: (e) => e.key === "Enter" && setShouldUpdate(true),
              onBlur: () => setShouldUpdate(true),
            },
            fieldSeparator: {
              children: "-",
              sx: { mx: 1 },
            },
          }}
        />
      </Box>
      <Box
        sx={{
          margin: "30px 0px 0px 0px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <CustomButton
          sx={{
            borderRadius: "15px",
            height: "30px",
          }}
          startIcon={<CloseIcon />}
          onClick={() => setReportModal(false)}
          variant="outlined"
        >
          {t("common:cancelShort")}
        </CustomButton>

        <CustomButton
          disabled={dateRange[0] === null || dateRange[1] === null}
          sx={{
            borderRadius: "15px",
            height: "30px",
          }}
          startIcon={<CheckIcon />}
          onClick={() => handleGenerateReport()}
          variant="contained"
        >
          {t("settings:createAndDownloadReport")}
        </CustomButton>
      </Box>
    </Box>
  );
};

export default UnionReportModal;
